import { render, staticRenderFns } from "./QsShipSection.vue?vue&type=template&id=161c52e6&"
import script from "./QsShipSection.vue?vue&type=script&lang=js&"
export * from "./QsShipSection.vue?vue&type=script&lang=js&"
import style0 from "./QsShipSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports